import { DOCUMENT, inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class JsonLdService {
  private document = inject(DOCUMENT);

  addJsonLd(jsonLdObject: unknown, id: string): void {
    const script = this.document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(jsonLdObject);
    script.id = id;
    this.document.head.appendChild(script);
  }

  removeJsonLd(id: string): void {
    const script = this.document.head.querySelector(`script[type="application/ld+json"][id="${id}"]`);
    if (script) {
      this.document.head.removeChild(script);
    }
  }
}
